// extracted by mini-css-extract-plugin
export default {"products":"ru-z","card":"su-z","oosMessaging":"tu-z"};